import React from "react";
import CountUp from 'react-countup';
import {Card, Container, Grid, Typography} from "@mui/material";
import styles from "../assets/css/recordAndBenefit.module.scss";

const RecordAndBenefit = (props) => {

    return <div className={styles.container}>
        <Container maxWidth={"xl"} component={"div"}>
            {props.records.map((item, index) => <div key={index}>
                <CountUp start={0} end={item.amount} delay={0} duration={4}>
                    {({countUpRef}) => (<Typography variant={"h4"} component={"h4"}>
                        <span ref={countUpRef}></span>
                    </Typography>)}
                </CountUp>
                <Typography variant={"overline"} component={"p"}>
                    {item.name}
                </Typography>
            </div>)}


        </Container>
        <img src={props.img} alt={""}/>
        <Container maxWidth={"xl"} component={"div"}>
            <Grid container>
                {props.benefit.map((item, index) =>
                    <Grid item xs={12} md={4}>
                        <Card elevation={3} component={"div"}>
                            <Typography variant={"h6"} component={"h4"}>
                                {item.title}
                            </Typography>
                            <Typography variant={"caption"} component={"p"}>
                                {item.description}
                            </Typography>
                        </Card>

                    </Grid>)}



            </Grid>

        </Container>
    </div>;
};

export default RecordAndBenefit;